import {StarOutlined} from '@ant-design/icons'
import IconWithNotification from '../IconWithNotification.jsx'
import ImportantNodes from './ImportantNodes.jsx'
import useImportantNodes from './useImportantNodes.mjs'

export default () => {
    const nodes = [...useImportantNodes()]

    return {
        icon: (
            <IconWithNotification notification={0 < nodes.length}>
                <StarOutlined />
            </IconWithNotification>
        ),

        key: 'important',
        name: '重要功能',
        pane: <ImportantNodes nodes={nodes} />,
    }
}
